<template>
  <upstream-sewage-wizard tool-name="Outpouring" title-translation-path="sidebar.upstreamSewage.outpouringTitle">
  </upstream-sewage-wizard>
</template>

<script>
import UpstreamSewageWizard from '@/components/UpstreamSewageWizard.vue';

export default {
  name: 'UpstreamSewageOutpouring',
  components: {
    UpstreamSewageWizard,
  },
};
</script>
